import React, { memo, useMemo, useCallback, DragEvent } from 'react';
import { CourseBuilder } from '../types';
import { BlockContainer } from '../BlockContainer';
import './index.scss';
import classNames from 'classnames';
import { formGroup, formControl, FormDataType } from '@core/utils/form';
import { defineBlockAdvanceForm } from '../Common/AdvanceSettings';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { useConfigureBlock } from '@modules/course/CourseBuilder/hooks';
import { R } from '@core/utils/r';
import { of } from 'rxjs';
import { Container } from 'reactstrap';
import { CourseBuilderFormData, useCourseBuilderContext } from '../../CourseBuilderPage';

function defineDividerBlockForm() {
  return formGroup({
    advance: defineBlockAdvanceForm({ paddingTop: 30, paddingBottom: 30 }),
  });
}

export type DividerWidgetFormData = FormDataType<typeof defineDividerBlockForm>;
export type DividerWidgetForm = ReturnType<typeof defineDividerBlockForm>;

export enum DividerBlockVariation {
  divider = 'divider',
  numbersDivider = 'numbersDivider',
}

export const DividerBlock = memo((props: CourseBuilder.BlockProps<DividerBlockVariation>) => {
  const { variation } = props;
  const courseBuilder = useCourseBuilderContext();
  const form = useMemo(defineDividerBlockForm, []);
  const formValue = useNonNilObservable(form.value$);
  const courseBuilderFormValue = useNonNilObservable(courseBuilder ? courseBuilder.form.value$ : of(null)) as null | CourseBuilderFormData;
  const dividerNumber = useMemo(() => {
    if (!courseBuilderFormValue) return 1;
    return (
      R.pipe(
        courseBuilderFormValue.blocks,
        R.ops.filter(block => block.type === CourseBuilder.BlockType.divider && block.variation === DividerBlockVariation.numbersDivider),
        R.ops.map(block => block.id),
        R.ops.indexOf(props.id),
      ) + 1
    );
  }, [courseBuilderFormValue, props.id]);

  useConfigureBlock({
    props,
    form,
  });

  return (
    <BlockContainer className={classNames('d-flex flex-fill h-100', 'block-divider', variation)} advanceForm={formValue.advance}>
      <Container>
        <div className="divider" style={{ backgroundColor: courseBuilderFormValue?.primaryColor || '#45A8F7' }}>
          {variation === DividerBlockVariation.numbersDivider && (
            <div style={{ backgroundColor: courseBuilderFormValue?.primaryColor || '#45A8F7' }} className="divider-number">
              {dividerNumber}
            </div>
          )}
        </div>
      </Container>
    </BlockContainer>
  );
});
